<template>
  <div class="row report-summary" style="margin:0">
      <div style="border-radius: 8px;padding: 16px 24px" class="col main-content-layout" v-for="(item, index) in dataReport" :key="index">
        <div>
            <p style="color: #74788D;">{{item.text}}</p>
            <h4 style="font-weight: 600;">{{item.value}}</h4>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    props: {
       dataReport: {
        type: Array,
        default: []
       },
    }

}
</script>

<style lang="scss">
.report-summary div:first-child {
    margin-right:16px
}
</style>